<template>
    <div>
      <div class="info-message">
        <span v-translate>Select the file you want to attach or </span>
        <span @click="addFile" class="link-text" v-translate>add a new document from your computer.</span>
      </div>
      <div class="table-container">
          <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
              <b-table 
                :items="items"
                :fields="fields"
                class="document-table"
                :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
                @row-clicked="rowClicked"
                responsive
                show-empty
                table-busy
              />
          </overlay-scrollbars>
      </div>
    </div>
</template>

<script>
import DocumentService from "@/store/services/document.service";

export default {
    name: "DocumentSelector",
    data() {
        return {
            items: [],
            fields: [
                {key: "title", label: this.$gettext('Title')},
                {key: "description", label: this.$gettext('Description')}
            ]
        }
    },
    created() {
        DocumentService.list({company_profile: window.company_id}).then((response) => {
          this.items = response.data.results;
          if (this.$route.params['documentId']) {
            this.items = this.items.filter((item) => item.id !== this.$route.params['documentId']);
          }
        });
    },
    methods: {
        rowClicked(item) {
            this.items = this.items.filter((it) => it.id !== item.id);
            this.$emit("documentSelected", item);
        },
        addFile() {
            this.$router.push({name: 'AddDocument'});
        }
    }
}
</script>

<style lang="scss" scoped>
.table-container {
    .os-host {
        max-height: 21rem !important;
        .os-content { 
            padding: 0 !important; 
        }
        margin-bottom: 0.25rem !important;
    }
}

@media(max-width: 840px) {
  .table-container {
    .os-host {
        height: 7rem !important;
    }
  }
}

.document-table {
  cursor: pointer;
  font-size: 16px;
  overflow: visible !important;
  thead {
    font-size: 14px;
    tr {
      th {
        background: #f8f8f8 !important;
      }
    }
  }
  tr {
    th, td {
      padding: 0.5rem 0.75rem;
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid $colorBorderDash;
    }
  }
}

.link-text {
  color: $colorBrand;
}

.link-text:hover {
  text-decoration: underline;
  cursor: pointer;
}

.info-message {
  display: block;
  padding: 1rem 0;
}

@media(max-width: 414px) {
  .info-message {
    display: none;
  }
}
</style>